// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__h+v0p","content":"Projects_content__EATNh"};